import React from 'react';
import { UploadIcon } from 'Icons';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ButtonIcon from 'components/IconButton';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  iconButton: {
    '&:hover': {
      background: 'transparent',
    },
  },
  icon: {
    // color: '#fff',
  },
  inheritFontSize: {
    // fontSize: '1.8rem',
  },
});

const UploadButton = ({
  onClick,
  className = '',
  title = 'Upload',
  white = false,
  theme,
  iconProps,
  ...props
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <ButtonIcon
      title={t(title)}
      component={UploadIcon}
      onClick={onClick}
      className={className}
      theme={theme}
      iconProps={{
        fontSize: 'inherit',
        className: classnames(classes.icon),
        classes: {
          fontSizeInherit: classes.inheritFontSize,
        },
        ...(!white && { color: 'disabled' }),
        ...iconProps,
      }}
      {...props}
    />
  );
};

UploadButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  theme: PropTypes.string,
  iconProps: PropTypes.object,
  white: PropTypes.bool,
};

export default UploadButton;
